import {
  GET_APPOINTMENT_LIST,
  GET_RESOURCE_LIST,
  GET_APPOINTMENT_DETAIL,
  RELOAD_CALENDAR,
  SELECT_RESOURCE,
  GET_FILTERED_LIST,
  GET_APPOINTMENT_SPECIFIC_DATE,
  CHECK_UPDATE,
  GET_LIST_SEARCH,
  GET_DEPOSIT_LIST, GET_DEPOSIT_DETAIL, CHANGE_DELETE_STATUS, CHANGE_ALL_DELETE_STATUS,
} from "./appointmentTypes";

export default {
  [GET_APPOINTMENT_LIST](state, data) {
    state.appointmentList = data;
  },

  [GET_RESOURCE_LIST](state, data) {
    state.resourceFilter = data;
    // if (typeof state.resource === 'undefined') {
    //   state.resourceList = data;
    // } else {
    //   if (state.resource != null) {
    //     for (let i = 0; i < data.length; i++) {
    //       if (data[i].id == state.resource.id) {
    //         state.resourceList = [data[i]];
    //         break;
    //       }
    //     }
    //   }
    // }

    if (state.resource.length == 0) {
      state.resourceList = data;
    } else {
      state.resourceList = [];
      for (let i = 0; i < data.length; i++) {
        // if (data[i].id == state.resource.id) {
        //   state.resourceList = [data[i]];
        //   break;
        // }
        for(let j = 0; j < state.resource.length; j++) {
          if(data[i].id == state.resource[j].id) {
            state.resourceList.push(data[i]);
          }
        }
      }
    }
  },

  [GET_APPOINTMENT_DETAIL](state, data) {
    state.appointmentDetail = data;
  },

  [RELOAD_CALENDAR](state, data) {
    state.calendarView = data;
    state.posCalendarView = data;
  },

  [SELECT_RESOURCE](state, data) {
    // state.resource = data;
    if(data && data != undefined) {
      let existedIndex = -1;
      if(state.resource && state.resource.length) {
        for(let i = 0; i < state.resource.length; i++) {
          if(state.resource[i].id == data.id) {
            existedIndex = i;
            break;
          }
        }
      }
      if(existedIndex != -1) {
        state.resource.splice(existedIndex, 1);
      } else {
        state.resource.push(data);
      }
    } else {
      state.resource = [];
    }
  },

  [GET_FILTERED_LIST](state) {
    let list = [];
    // if (state.resource == null) {
    if (state.resource.length == 0) {
      if (state.calendarView.type == "1d" || state.calendarView.type === undefined) {
        list = state.appointmentList;
      }
      else {
        for (let i = 0; i < state.appointmentList.length; i++) {
          if (state.appointmentList[i].rendering != "background" || state.appointmentList[i].resourceId == null) {
            list.push(state.appointmentList[i]);
          }
        }
      }
    } else {
      for (let i = 0; i < state.appointmentList.length; i++) {
        // if (state.appointmentList[i].resourceId == state.resource.id || state.appointmentList[i].resourceId == null) {
        //   list.push(state.appointmentList[i]);
        // }
        for(let j = 0; j < state.resource.length; j++) {
          if (state.appointmentList[i].resourceId == state.resource[j].id || state.appointmentList[i].resourceId == null) {
            list.push(state.appointmentList[i]);
          }
        }
      }
    }
    state.filteredList = list;
  },

  [GET_APPOINTMENT_SPECIFIC_DATE](state, data) {
    state.specificDate = data;
  },

  [CHECK_UPDATE](state, data) {
    state.currentId = data;
  },

  [GET_LIST_SEARCH](state, data) {
    state.appointmentSearchList = data;
  },

  [GET_DEPOSIT_LIST](state, data) {
    if(data && data.items && data.items.length > 0) {
      for(let i = 0; i < data.items.length; i++) {
        data.items[i].delete_status = false;
      }
    }
    state.depositDeleteStatus.isAllSelected = false;
    state.depositDeleteStatus.selectedNum = 0;
    state.depositList = data;
  },

  [GET_DEPOSIT_DETAIL](state, data) {
    state.depositDetail = data;
  },

  [CHANGE_DELETE_STATUS](state, index) {
    let depositList = state.depositList;
    if(depositList.items && depositList.items[index]) {
      depositList.items[index].delete_status = !depositList.items[index].delete_status;

      let selectedNum = 0;
      for(let i = 0; i < depositList.items.length; i++) {
        if(depositList.items[i].delete_status) {
          selectedNum++;
        }
      }

      if(selectedNum == depositList.items.length) {
        state.depositDeleteStatus.isAllSelected = true;
      } else {
        state.depositDeleteStatus.isAllSelected = false;
      }
      state.depositDeleteStatus.selectedNum = selectedNum;
      state.depositList = depositList;
    }
  },

  [CHANGE_ALL_DELETE_STATUS](state, status) {
    let depositList = state.depositList;
    if(depositList.items && depositList.items.length > 0) {
      for(let i = 0; i < depositList.items.length; i++) {
        depositList.items[i].delete_status = status;
      }
    }
    state.depositDeleteStatus.isAllSelected = status;
    state.depositDeleteStatus.selectedNum = status ? depositList.items.length : 0;
    state.depositList = depositList;
  }
}
